import { createStyles, Theme } from '@material-ui/core'
import { fade } from '@material-ui/core/styles/colorManipulator'
import { makeStyles } from '@material-ui/core/styles'

/** Matches app `MuiDialog` paper shadow (`theme/index.ts`) */
const dialogPaperShadow = '0 12px 48px rgba(0, 0, 0, 0.14)'

export const useShipmentRateBlockStyle = makeStyles((theme: Theme) =>
  createStyles({
    nameLine: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      width: '100%',
    },
    icon: {
      color: theme.palette.primary.light,
      fontSize: 13,
      cursor: 'pointer',

      '&:hover': {
        color: theme.palette.primary.dark,
      },
    },
    loader: {
      display: 'block',
      alignItems: 'center',
      width: '100%',
    },
    paper: {
      position: 'absolute',
      width: '100%',
      maxWidth: theme.spacing(65),
      backgroundColor: theme.palette.background.paper,
      boxShadow: dialogPaperShadow,
      padding: theme.spacing(5, 3, 2.5),
      borderRadius: theme.shape.borderRadius * 3,
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'min(90vh, 580px)',
      overflow: 'hidden',
      '&:focus': {
        outline: 'none',
      },
    },
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '25ch',
      },
    },
    marginButton: {
      margin: theme.spacing(1),
    },
    modal: {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    form: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    link: {
      cursor: 'pointer',
    },
    fullScreen: {
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      borderRadius: 0,
      minHeight: '100%',
      maxHeight: '100%',
    },
    closeIcon: {
      position: 'absolute',
      right: theme.spacing(0.5),
      top: theme.spacing(0.5),
      color: theme.palette.grey[600],
      padding: theme.spacing(1),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.black, 0.06),
      },
    },
    ratesHolder: {
      width: '100%',
      textAlign: 'left',
    },
    ratesWrapper: {
      width: '100%',
      textAlign: 'left',
    },
    ratesItemHolder: {
      display: 'block',
    },
    rateItem: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      borderRadius: theme.shape.borderRadius * 2,
      boxSizing: 'border-box',
    },
    rateItemBorder: {
      border: `2px solid ${fade(theme.palette.common.black, 0.12)}`,
      padding: theme.spacing(2, 2.25),
      cursor: 'pointer',
      transition: theme.transitions.create(['border-color', 'box-shadow'], {
        duration: theme.transitions.duration.shortest,
      }),
      '&:hover': {
        borderColor: fade(theme.palette.primary.main, 0.55),
        boxShadow: `0 1px 4px ${fade(theme.palette.common.black, 0.06)}`,
      },
    },
    rateSelectedItem: {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 1px ${fade(theme.palette.primary.main, 0.35)}`,
    },
    rateSelectionBadge: {
      position: 'absolute',
      top: theme.spacing(1.5),
      right: theme.spacing(1.5),
      width: theme.spacing(2.75),
      height: theme.spacing(2.75),
      borderRadius: '50%',
      backgroundColor: theme.palette.common.black,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
    },
    rateSelectionCheck: {
      fontSize: theme.spacing(2),
      color: theme.palette.common.white,
    },
    rateLogo: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: theme.spacing(8.75),
      height: theme.spacing(8.75),
      marginRight: theme.spacing(1.75),
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: theme.spacing(8.75),

      '& img': {
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
      },
    },
    rateAmount: {
      display: 'block',
      fontWeight: 700,
      fontSize: '1rem',
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(0.25),
      letterSpacing: '-0.01em',
    },
    ratesListWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1.5),
      padding: theme.spacing(0.5, 0, 1),
    },
    rateListHolder: {
      flex: 1,
      minHeight: 0,
      overflowX: 'hidden',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
    },
    rateInfoHolder: {
      textAlign: 'left',
    },
    rateInfo: {
      color: theme.palette.text.secondary,
      fontSize: '0.8125rem',
      fontWeight: 500,
      lineHeight: 1.45,
      display: 'block',
    },
    serviceLevelName: {
      color: theme.palette.grey[600],
      fontSize: '0.8125rem',
      fontWeight: 600,
      display: 'block',
      marginBottom: theme.spacing(0.5),
      lineHeight: 1.35,
    },
    btnBlock: {
      paddingTop: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1.25),
      flexShrink: 0,
    },
    modalActionBtn: {
      borderRadius: theme.shape.borderRadius * 2,
      fontWeight: 700,
      textTransform: 'none',
      paddingTop: theme.spacing(1.25),
      paddingBottom: theme.spacing(1.25),
      fontSize: '0.9375rem',
    },

  })
)
